"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _Translations = require("./Translations");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ConfirmationDialog(props) {
  var theme = (0, _core.useTheme)();
  var disableCloseAction = props.disableCloseAction || false;
  return /*#__PURE__*/_react.default.createElement(_core.Dialog, _extends({
    open: props.open,
    fullWidth: true
  }, !disableCloseAction && {
    onClose: props.close
  }), /*#__PURE__*/_react.default.createElement(_core.DialogTitle, {
    style: {
      color: theme.palette.primary.main
    }
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: props.title,
    defaultMessage: props.title
  })), props.description && /*#__PURE__*/_react.default.createElement(_core.DialogContent, null, /*#__PURE__*/_react.default.createElement(_core.DialogContentText, {
    id: "alert-dialog-slide-description"
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: props.description,
    defaultMessage: props.description
  }))), /*#__PURE__*/_react.default.createElement(_core.DialogActions, null, !disableCloseAction && /*#__PURE__*/_react.default.createElement(_core.Button, {
    onClick: props.close
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: props.closeLabel,
    defaultMessage: props.closeLabel
  })), /*#__PURE__*/_react.default.createElement(_core.Button, {
    onClick: props.confirmAction,
    variant: "contained",
    color: "primary"
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: props.confirmLabel,
    defaultMessage: props.confirmLabel
  }))));
}
var _default = ConfirmationDialog;
exports.default = _default;